import Backbone from 'backbone'
import conductor from 'scoreboard/components/conductor'
import _ from 'lodash'
import spectator from 'scoreboard/components/spectator'
import metadata from 'scoreboard/components/metadata'
import appDisplay from 'scoreboard/components/app-display'
import notImplemented from 'scoreboard/components/not-implemented.hbs'
import EmptyState from 'scoreboard/components/empty-state'
import i18n from 'scoreboard/components/i18n'
import deleteDomainObject from 'scoreboard/components/edit/delete-domain-object'

function BookmarksOverview(options) {
	this.model = options && options.model
}

_.extend(BookmarksOverview.prototype, Backbone.Events, {

	// this.model is the current Bookmark

	render: function() {
		spectator.setCurrent(this.model)
		handleDeletedBookmark(this.model, BookmarksOverview.prototype)

		// load the URL without changing the URL for the browser
		var foundRoute = Backbone.history.loadUrl(this.model.getStatefulUrl(),
			{ preventWelcomeRedirect: true })

		if (!foundRoute) {
			appDisplay.display(new EmptyState({
				body: notImplemented(metadata.bookmarks)
			}))
		}

		// change what's in the URL bar
		// issue #6944 use { replace: true } or back button must be clicked
		// multiple times to go back
		conductor.navigate('bookmarks/' + this.model.id, { replace: true })

		return this
	}
})

/**
 * Set and unset the spectator when appropriate and show delete button for missing bookmarks
 * @param model
 */
function handleDeletedBookmark(model, viewPrototype) {
	const onRenderDisplay = (view) => {
		// Item doesn't exist - delete option. Issue #16814
		// The initial empty-state is rendered from the base-router and
		// it doesn't know the item is related to a bookmark at that point.
		// Therefore, we need to add the button manually in the overview section.
		if (!_.isNil(view.$el) && view.options && view.options.notFound) {
			// Will get rebound.
			view.$('.delete').off('click')
			// Prevent multiple delete buttons from getting appended when
			// switching between different bookmarks.
			if (!view.options.notFoundButtonAppended) {
				view.options.notFoundButtonAppended = true
				view.$('.empty-state-message')
					// Intentionally using a primary-button for the delete-button,
					// because it is an encouraged action in this case.
					.append(`<button class="button button-primary delete">${i18n.get('bookmarks.delete')}</button>`)
			}
			view.$('.delete').on('click', () => deleteDomainObject(model))
		}

		// #10959 #11378 #11707 #23474 clear out the spectator safely
		if (Object.getPrototypeOf(view) != viewPrototype) {
			spectator.setCurrent(null)
			appDisplay.off('render:display', onRenderDisplay)
		}
	}

	appDisplay.on('render:display', onRenderDisplay)
}

export default BookmarksOverview
export { handleDeletedBookmark }

BookmarksOverview.__filename__ = 'bookmarks/bookmarks-overview.js'
